export default __webpack_public_path__ + "static/media/logo-email.1c1d65bf.png";